export default "__VITE_ASSET__BTFNTQCR__"